export { default as Divider } from 'primevue/divider';
